import { createSlice } from "@reduxjs/toolkit";

import { compareInString } from "../../../container/SportsBookNode/utils/common/functions";

const initialState = {
  loading: false,
  matchIds: [],
  error: false,
  success: false,
  updatedMatchId: ""
};

const FavouriteSlice = createSlice({
  name: "Favourites",
  initialState,
  reducers: {
    addOrRemoveFavouriteStart: (state, action) => {
      state.loading = true;
      state.error = false;
      state.matchIds.push(action?.payload?.matchId);
      state.updatedMatchId = "";
    },
    addOrRemoveFavouriteSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.updatedMatchId = action?.payload;
      state.matchIds = state.matchIds.filter(
        (id) => !compareInString(id, action?.payload?.matchId)
      );
    },
    addOrRemoveFavouriteFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = true;
    }
  }
});

export const {
  addOrRemoveFavouriteStart,
  addOrRemoveFavouriteSuccess,
  addOrRemoveFavouriteFailure
} = FavouriteSlice.actions;

export default FavouriteSlice.reducer;
